// ** IMPORTANT **: Keep in sync with functions/src/index.ts AUTH_ACTION_QUERY_PARAM
export enum AUTH_ACTION_QUERY_PARAM {
    mode = 'mode',
    oobCode = 'oobCode',
    continueUrl = 'continueUrl',
    mailTrackingId = 'mailTrackingId',
    ownerUserId = 'ownerUserId',
    assignmentId = 'assignmentId',
    claimToken = 'claimToken',
    claimLookupToken = 'claimLookupToken',
    platform = 'platform',
    test = 'test',
}
